import { render, staticRenderFns } from "./Invoicebill.vue?vue&type=template&id=38b21c96"
import script from "./Invoicebill.vue?vue&type=script&lang=js"
export * from "./Invoicebill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports